import createEnum from 'scripts/lib/create_enum';

export const ChatMessageStatusCode = createEnum('FAILED', 'NEW', 'SENT');
export const ChatMessageType = createEnum(
  'ACTION_SELECTED',
  'BUTTON_PROMPT_SELECTED',
  'COMPOSITE_MESSAGE',
  'DATA_DISPLAY',
  'HTML',
  'FLEXIBLE_CARD',
  'QUICK_REPLY_REQUEST',
  'QUICK_REPLY_RESPONSE',
  'TEXT'
);
export const ChatPlatform = createEnum('ANDROID', 'IOS', 'WEB');
export const OutgoingChatOperation = createEnum('END_CHAT', 'SEND_CHAT_MESSAGE', 'REQUEST_CREDIT_CARD');
